import * as Sentry from '@sentry/react';

const addSentryLoggingInterceptor = axiosInstance => {
  axiosInstance.interceptors.response.use(
    response => response,
    error => {
      // defesa extra: se algum interceptor anterior rejeitar com undefined/null (ver
      // handleAuthError), não deixa a desestruturação virar unhandled rejection aqui.
      if (!error) {
        return Promise.reject(error);
      }
      const { config, response } = error;

      const duration = new Date().getTime() - (config?.metadata?.startTime?.getTime?.() || 0);

      let errorType = 'unknown';
      if (!response) {
        errorType = 'network_error';
      } else if (response.status >= 400 && response.status < 500) {
        errorType = 'client_error';
      } else if (response.status >= 500) {
        errorType = 'server_error';
      }

      const capturedError =
        error instanceof Error
          ? error
          : new Error(error?.message || error?.statusText || `HTTP ${error?.status ?? 'unknown'}`);

      Sentry.captureException(capturedError, {
        tags: {
          endpoint: config?.url,
          method: config?.method,
          status: response?.status,
          error_type: errorType,
        },
        contexts: {
          request: {
            url: config?.url,
            method: config?.method,
            params: config?.params,
            body: config?.data,
            headers: config?.headers,
          },
          response: {
            status: response?.status,
            data: response?.data,
            headers: response?.headers,
          },
          network: {
            duration_ms: duration,
          },
        },
      });

      return Promise.reject(error);
    },
  );
};
export { addSentryLoggingInterceptor };
